export const DEFAULT_BOOK_COVER = "default/default_f7f7f7_book_cover.png";
